module.exports = __webpack_public_path__ + "media/video2-pc.fa985d5e.mp4";